export default __webpack_public_path__ + "static/media/kumaraswamy_family.ddd695f0.jpg";